import React from "react";
import { Grid } from "@mui/material";
function Slideone({ onNext, handleOpen, formState }) {
  const handleNext = () => {
    onNext();
  };

  return (
    <div className="mobbackofslidesix">
      <div>
        <br />
        <br />
        <br />

        <div className="container">
          <Grid container spacing={10}>
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
              sm={12}
              style={{ textAlign: "center" }}
            >
              <h1 className="head_of_slidetwo">
                {" "}
                Can {formState.user_name} provide{" "}
                <span style={{ color: "#D000C5", fontWeight: "900" }}>
                  quality pictures
                </span>{" "}
                of the artworks?
              </h1>
              <br />
              <p
                style={{ textAlign: "center", color: "#9B9DAF" }}
                className="para_of_slideone"
              >
                Quality photos boost Gallery conversion rates and improve the
                browsing experience for art lovers and collectors. As such, all
                artworks listed for sale on Suarte must meet quality standards.
              </p>
              <button className="myButton_head_Desktop_Choose_pink_zancc" style={{
                      background: "transparent",
                      border: "none",
                    }} >
                Yes, next
              </button>
            </Grid>
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
              sm={12}
              style={{
                textAlign: "center",
                position: "relative",
                top: "-50px",
              }}
            >
              <h1 className="head_of_slidetwo">
                {" "}
                Can {formState.user_name}{" "}
                <span style={{ color: "#D000C5", fontWeight: "900" }}>
                  ship
                </span>{" "}
                artworks{" "}
                <span style={{ color: "#D000C5", fontWeight: "900" }}>
                  internationally
                </span>{" "}
                ?
              </h1>
              <br />
              <p
                style={{ textAlign: "center", color: "#9B9DAF" }}
                className="para_of_slideone"
              >
                When uploading an artwork, you choose whether the collector or
                the Gallery will cover shipping costs, with the option to set
                and save different fees per zone.
                <br /> <br />
                Suarte recommends consulting different courier companies for
                international shipping rates.
              </p>
              <button
                href="#"
                className="myButton_head_Desktop_Choose_pink_zancgg"
                onClick={handleOpen}
              >
                No, exit
              </button>{" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button
                href="#"
                className="myButton_head_Desktop_Choose_pink_zanck"
                onClick={handleNext}
              >
                Yes, next
              </button>
              <div className="gender_drop"></div>
              <br />
              <br />
              <br />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Slideone;
